import React from "react"
import ContentLoader from "react-content-loader"

const InboxLoader = (props) => (
  <ContentLoader 
    speed={2}
    width={1340}
    height={650}
    viewBox="0 0 1200 650"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="31" y="130" rx="0" ry="0" width="0" height="9" /> 
    <rect x="8" y="18" rx="0" ry="0" width="32" height="21" /> 
    <rect x="48" y="22" rx="0" ry="0" width="81" height="12" /> 
    <rect x="8" y="54" rx="0" ry="0" width="370" height="6" /> 
    <rect x="400" y="3" rx="0" ry="0" width="4" height="600" /> 
    <rect x="425" y="18" rx="0" ry="0" width="32" height="21" /> 
    <rect x="480" y="22" rx="0" ry="0" width="81" height="12" /> 
    <rect x="1170" y="17" rx="0" ry="0" width="29" height="18" /> 
    <rect x="425" y="54" rx="0" ry="0" width="780" height="6" /> 
    <rect x="8" y="75" rx="0" ry="0" width="70" height="11" /> 
    <rect x="8" y="102" rx="0" ry="0" width="370" height="65" /> 
    <rect x="8" y="184" rx="0" ry="0" width="370" height="6" /> 
    <rect x="8" y="206" rx="0" ry="0" width="370" height="65" /> 
    <rect x="8" y="288" rx="0" ry="0" width="370" height="6" /> 
    <rect x="6" y="310" rx="0" ry="0" width="370" height="65" /> 
    <rect x="6" y="392" rx="0" ry="0" width="370" height="6" /> 
    <rect x="6" y="410" rx="0" ry="0" width="370" height="65" /> 
    <rect x="6" y="492" rx="0" ry="0" width="370" height="6" /> 
    <circle cx="1172" cy="113" r="28" /> 
    <rect x="1020" y="94" rx="0" ry="0" width="99" height="30" /> 
    <circle cx="450" cy="188" r="29" /> 
    <rect x="500" y="167" rx="0" ry="0" width="100" height="28" /> 
    <rect x="500" y="199" rx="0" ry="0" width="150" height="10" /> 
    <rect x="970" y="132" rx="0" ry="0" width="150" height="10" /> 
    <circle cx="1172" cy="263" r="28" /> 
    <rect x="1020" y="244" rx="0" ry="0" width="99" height="30" /> 
    <circle cx="450" cy="338" r="29" /> 
    <rect x="500" y="317" rx="0" ry="0" width="100" height="28" /> 
    <rect x="500" y="349" rx="0" ry="0" width="150" height="10" /> 
    <rect x="970" y="282" rx="0" ry="0" width="150" height="10" /> 
    <circle cx="1172" cy="405" r="28" /> 
    <rect x="1020" y="386" rx="0" ry="0" width="99" height="30" /> 
    <circle cx="450" cy="480" r="29" /> 
    <rect x="500" y="459" rx="0" ry="0" width="100" height="28" /> 
    <rect x="500" y="491" rx="0" ry="0" width="150" height="10" /> 
    <rect x="970" y="424" rx="0" ry="0" width="150" height="10" /> 
    <rect x="425" y="522" rx="0" ry="0" width="780" height="6" /> 
    <circle cx="1170" cy="566" r="21" /> 
    <rect x="425" y="553" rx="0" ry="0" width="95" height="12" /> 
    <rect x="8" y="598" rx="0" ry="0" width="1200" height="5" />
  </ContentLoader>
)

export default InboxLoader;
